import * as React from "react";
import { forwardRef } from "react";
const SvgIcMinus = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19 11.25L19.0771 11.2539C19.4551 11.2925 19.75 11.6118 19.75 12C19.75 12.3882 19.4551 12.7075 19.0771 12.7461L19 12.75H5C4.58579 12.75 4.25 12.4142 4.25 12C4.25 11.5858 4.58579 11.25 5 11.25H19Z", fill: "#241D47" }));
const ForwardRef = forwardRef(SvgIcMinus);
export default ForwardRef;
